/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */

import styled from 'styled-components'

export const AlternativeDefinitionsTitle = styled.span`
	font-weight: bold;
	font-size: 18px;
`

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 0px 20px 20px;
`
